module.exports = __webpack_public_path__ + "static/media/83 - Stretch - Why did you do it.4bfe78b5.mp3";